import adminApiConfig from '../data/admin-api.json';
import baseURLConfig from '../../data/api-baseurl.json';

const getBaseURL = (): string => {
  const config = baseURLConfig as Record<string, string>;

  if (typeof window === 'undefined') {
    return config.default;
  }

  const hostname = window.location.hostname;
  return config[hostname] || config.default;
};

export const getAdminEndpointUrl = (category: string, endpoint: string, params?: Record<string, string>): string => {
  const endpoints = adminApiConfig.endpoints as Record<string, Record<string, string>>;
  let path = endpoints[category]?.[endpoint];

  if (!path) {
    throw new Error(`Admin endpoint not found: ${category}.${endpoint}`);
  }

  // Reemplazar parametros de ruta ({id} -> valor)
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      path = path.replace(`{${key}}`, encodeURIComponent(value));
    }
  }

  return `${getBaseURL()}${path}`;
};
